import { React, useState, useEffect, Breadcrumb } from "../utils/commonImports";
import GridView from '../components/GridView';
import { Alert, Card } from "antd";
import Select from "react-select";
import { _api } from '../auth/Api';
import dayjs from "dayjs";
import { customStyleMd } from "../utils/common";

const Vehicles = () => {
  const [partsList, setPartsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ctgDrp, setCtgDrp] = useState([]);
  const [partsDrp, setPartsDrp] = useState([]);
  const [showExp, setShowExp] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0)

  const [filters, setFilters] = useState({
    name: "",
    code: "",
    category: null,
    fromDate: null,
  });

  useEffect(() => {
    _getParts();
  }, []);

  const _getParts = async (filterValues = {}) => {
    setShowExp(false)
    const payload = {
      partId: null,
      partName: filterValues.name || "",
      category: filterValues.category?.value || "",
      code: filterValues.code || "",
      createDate: filterValues.fromDate ? dayjs(filterValues.fromDate).format("YYYY-MM-DD") : "",
      page: {
        pageNo: 0,
        numberOfRecords: 0
      },
    };
    const isInitialOrReset = !payload.partName && !payload.category && !payload.createDate && !payload.code;
    try {
      setLoading(true);
      await _api("POST", "Part/GetFilteredParts", payload, (res) => {
        if (res.isSuccess) {
          setTotalRecords(res.totalRecords)
          if (isInitialOrReset) {
            const uniqueCtg = res.data.filter(
              (v, index, self) =>
                index === self.findIndex((t) => t.category === v.category)
            );
            const drpCtg = uniqueCtg.map((x) => ({
              value: x.category,
              label: x.category
            }))
            setCtgDrp(drpCtg)

            const drpParts = res.data?.map((x) => ({
              value: x.partId,
              label: x.partName
            }))
            setPartsDrp(drpParts)
          }
          setPartsList(res?.data || []);
        } else {
          setPartsList([]);
        }
        setLoading(false);
      });
    } catch (error) {
      console.log("API Error", error?.message);
      setPartsList([]);
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFilters({
      name: "",
      code: "",
      category: null,
      fromDate: null,
    });
    _getParts();
  };

  const handleApply = () => {
    const { name, category, fromDate, code } = filters;
    if (!name && !category && !fromDate && !code) {
      setShowExp(true);
      return;
    }
    _getParts(filters);
  };

  return (
    <>
      <Breadcrumb title="Car Parts" />
      <Card className="mb-3">
        {/* Filters */}
        <div className="p-2 bg-white">
          <div className="row g-2">
            <div className="col-md-3">
              <Select
                options={partsDrp}
                value={partsDrp.find(opt => opt.label === filters.name) || null}
                onChange={(val) => setFilters({ ...filters, name: val?.label || "" })}
                placeholder="Search Part"
                isClearable
                styles={customStyleMd}
                filterOption={(option, inputValue) =>
                  inputValue ? option.label.toLowerCase().includes(inputValue.toLowerCase()) : false
                }
                noOptionsMessage={() => "Type to search..."}
              />
            </div>

            <div className="col-md-3">
              <input
                type="text"
                className="form-control"
                placeholder="Part Code"
                value={filters.code}
                onChange={(e) => setFilters({ ...filters, code: e.target.value })}
              />
            </div>

            <div className="col-md-3">
              <Select
                options={ctgDrp}
                value={filters.category}
                onChange={(val) => setFilters({ ...filters, category: val })}
                placeholder="Select Category"
                isClearable
                styles={customStyleMd}
              />
            </div>

            {/* <div className="col-md-3">
              <DatePicker
                format="YYYY-MM-DD"
                value={filters.fromDate ? dayjs(filters.fromDate) : null}
                onChange={(date) => setFilters({ ...filters, fromDate: date })}
                style={{ width: "100%" }}
                disabledDate={(current) => current && current > dayjs().endOf("day")}
                placeholder="From Date"
              />
            </div> */}
            <div className="col-md-3 d-flex align-items-center justify-content-end gap-2">
              <button className="btn btn-sm btn-outline-secondary" onClick={handleReset}>Reset Filter</button>
              <button className="btn btn-sm btn-primary" onClick={handleApply}>Apply Filters</button>
            </div>
          </div>
          {showExp && <Alert showIcon message="NOTE: Please fill at least one filter" type="warning" className="mt-3" />}
        </div>
      </Card>

      <GridView
        data={partsList}
        totalRecords={totalRecords}
        loading={loading}
        config={{
          searchField: "partName",
          titleField: "partName",
          subtitleField: "category",
          imageField: "imageUrl",
          emptyMessage: "No parts found",
          extraFields: [
            { label: "MRP", key: "mrp", prefix: "Rs. " },
            { label: "Code", key: "code" },
          ],
        }}
      />
    </>
  );
};

export default Vehicles;